import { atomFamily } from "recoil";

export const isOpenWithParamsState = atomFamily({
  key: "isOpenWithParams",
  default: { status: false, params: {} },
});
